<template>
  <div style="width: 100%">
    <b-row align-h="center">
      <b-col
        v-if="areaIdList.length > 0"
        cols="6"
      >
        <div
          style="height: 35px; margin-bottom: 30px"
        >
          <h4
            class="text-center"
            style="color: #8d949d; font-weight: 300"
          >
            {{ $t('action_center.confirmation_header') }}
          </h4>
        </div>
        <div v-if="accountIdList">
          <div v-for="accountId in accountIdList" :key="accountId">
            <div
              v-if="user.role === 'admin'"
              style="height: 35px; margin-bottom: 30px"
            >
              <h4
                class="text-center"
                style="color: #8d949d; font-weight: 300"
              >
                {{ getShiftByAccountId(accountId).pop().account ? getShiftByAccountId(accountId).pop().account.name : '' }}
              </h4>
            </div>
            <b-card
              v-for="(areaId, index) in getAreasByAccountId(accountId)"
              :key="areaId"
              class="text-capitalize w-full"
            >
              <template #header>
                <div class="header-container">
                  <div style="display: flex; flex-direction: column;">
                    <span style="font-size: 20px; font-weight: 500;">
                      {{ getShiftByAreaId(areaId).pop().area.name }}
                    </span>
                    <span style="font-size: 16px; font-weight: 300; text-transform: none; margin-top: 5px;">
                      {{ `Varatut vuorot: ${getShiftByAreaId(areaId).length}` }}
                    </span>
                    <span v-if="appConfig.type === 'hw-admin'" style="font-size: 16px; font-weight: 300; text-transform: none;">
                      {{ `Vahvistusviesti lähetetty: ${getVerifMsgSentCount(getShiftByAreaId(areaId))}/${getShiftByAreaId(areaId).length}` }}
                    </span>
                  </div>
                  <div style="display: flex; flex-direction: column;">
                    <b-button
                      v-if="appConfig.type === 'hw-admin'"
                      type="button"
                      variant="outline-warning"
                      class="mt-1"
                      :disabled="(sendingVerificationMessage && verificationMessageData.id === areaId && verificationMessageData.index === index && verificationMessageData.action === 'multiple_msg') || !getShiftByAreaId(areaId).some(shift => shift.reservation.step === 2)"
                      @click="showModalSendVerificationMessage('area', areaId, index, 'multiple_msg')"
                    >
                      Lähetä vahvistuskooste
                      <b-spinner
                        v-if="sendingVerificationMessage && verificationMessageData.id === areaId && verificationMessageData.index === index && verificationMessageData.action === 'multiple_msg'"
                        small
                        style="margin-left: 5px;"
                      />
                    </b-button>
                    <b-button
                      type="button"
                      variant="outline-primary"
                      class="mt-1"
                      :disabled="(sendingVerifications && verifyShiftsData.id === areaId && verifyShiftsData.index === index && verifyShiftsData.action === 'multiple_verify')"
                      @click="showModalVerifyShifts('area', areaId, index, 'multiple_verify', !getShiftByAreaId(areaId).some(shift => shift.reservation.step === 2))"
                    >
                      Vahvista kaikki vuorot
                    </b-button>
                    <b-spinner
                      v-if="sendingVerifications && verifyShiftsData.id === areaId && verifyShiftsData.index === index && verifyShiftsData.action === 'multiple_verify'"
                      small
                      style="margin-left: 5px;"
                    />
                  </div>
                </div>
              </template>

              <b-card-text>
                <app-collapse v-if="getShiftByAreaId(areaId).length > 0">
                  <app-collapse-item
                    :is-visible="areaIdList.length === 1"
                    title=""
                  >
                    <app-timeline>
                      <app-timeline-item
                        v-for="(shift, index) in getShiftByAreaId(areaId)"
                        :key="`${shift.contractId}${index}`"
                        variant="warning"
                        class="ml-2 d-flex justify-content-between"
                      >
                        <b-card
                          title="Vuoron tiedot"
                          style="text-transform: none;"
                        >
                          <b-card-text style="text-transform: capitalize;">{{ `Tilaaja: ${getProcessor(shift)}` }}</b-card-text>
                          <b-card-text style="text-transform: none; margin-top: -10px;">{{ `Vuoron alkuun ${shift.daysTill > 0 ? `${shift.daysTill} ${shift.daysTill === 1 ? 'päivä' : 'päivää'}` : `${shift.hoursTill} tuntia ${shift.minutesTill - (shift.hoursTill * 60) + 1} minuuttia`}`}}</b-card-text>
                          <app-collapse style="margin-top: -10px;">
                            <app-collapse-item
                              :title="`${$t('action_center.capacitor', { msg: 'Varaaja' })}: ${shift.user.fullName}`"
                              style="margin-left: -15px; text-transform: capitalize;"
                            >
                              <b-card-text class="ml-1">
                                {{ $t('profession') }}:
                                <span style="text-transform: capitalize; font-weight: 600">
                                  {{ shift.user.role }}
                                </span>
                              </b-card-text>

                              <!-- Check if user is student -->
                              <b-card-text
                                v-if="shift.user.profession && shift.user.profession === 'opiskelija'"
                                class="ml-1"
                              >
                                {{ shift.user.profession }}:
                                <span style="text-transform: capitalize; font-weight: 600">
                                  {{ shift.user.studies ? shift.user.studies.credits : '' }}
                                </span>
                              </b-card-text>

                              <b-card-text v-if="appConfig.type === 'hw-admin'" class="ml-1">
                                {{ $t('action_center.permission') }}:
                                <span style="text-transform: capitalize; font-weight: 600">
                                  {{ shift.user.love ? $t('action_center.permissible', { msg: 'Luvallinen' }) : $t('action_center.unauthorized', { msg: 'Luvaton' }) }}
                                </span>
                              </b-card-text>

                              <b-card-text class="ml-1">
                                {{ $t('action_center.phone_number', { msg: 'Phone Number' }) }}:
                                <span style="text-transform: lowercase; font-weight: 600">
                                  {{ shift.user.mobile }}
                                </span>
                              </b-card-text>
                              <b-card-text class="ml-1">
                                {{ $t('action_center.email') }}:
                                <span style="text-transform: lowercase; font-weight: 600">
                                  {{ shift.user.email }}
                                </span>
                              </b-card-text>
                              <b-card-text v-if="appConfig.type === 'hw-admin'" class="ml-1">
                                {{ $t('birthday') }}:
                                <span style="text-transform: lowercase; font-weight: 600">
                                  {{ shift.user.birthday }}
                                </span>
                              </b-card-text>
                            </app-collapse-item>
                          </app-collapse>

                          <b-card-text>
                            {{ $t('action_center.start_str') }}: {{ shift.start.toLocaleString('fi', {month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'}) }}
                          </b-card-text>

                          <b-card-text>
                            {{ $t('action_center.end_str') }}: {{ shift.end.toLocaleString('fi', {month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'}) }}
                          </b-card-text>

                          <div style="display: flex; flex-direction: column;">
                            <b-badge
                              v-if="shift.isWorkedInArea"
                              pill
                              variant="light-success"
                              style="text-transform: none; margin-bottom: 5px; width: fit-content;"
                            >
                              <feather-icon
                                icon="CheckCircleIcon"
                                class="mr-25"
                                stroke-width="2"
                              />
                              {{ $t('action_center.worked_in_area') }}
                            </b-badge>
                            <b-badge
                              v-else
                              pill
                              variant="light-warning"
                              style="text-transform: none; margin-bottom: 5px; width: fit-content;"
                            >
                              <feather-icon
                                icon="AlertCircleIcon"
                                class="mr-25"
                                stroke-width="2"
                              />
                              {{ $t('action_center.newToArea') }}
                            </b-badge>
                            <b-badge
                              v-if="shift.user.profession && shift.user.profession === 'opiskelija'"
                              pill
                              variant="light-success"
                              style="text-transform: uppercase; margin-bottom: 5px; width: fit-content;"
                            >
                              {{ shift.user.profession }}
                            </b-badge>
                            <b-badge
                              v-if="shift.tentative"
                              pill
                              variant="light-danger"
                              style="text-transform: uppercase; margin-bottom: 5px; width: fit-content;"
                            >
                              Alustava vuoro
                            </b-badge>
                          </div>
                        </b-card>
                        <div class="d-flex flex-column">
                          <b-button
                            v-if="appConfig.type === 'hw-admin'"
                            type="button"
                            variant="outline-warning"
                            class="mt-1"
                            :disabled="(sendingVerificationMessage && verificationMessageData.id === shift.id && verificationMessageData.index === index && verificationMessageData.action === 'single_msg') || shift.reservation.step > 2"
                            @click="showModalSendVerificationMessage('shift', shift.id, index, 'single_msg')"
                          >
                            Lähetä vahvistusviesti
                            <b-spinner
                              v-if="sendingVerificationMessage && verificationMessageData.id === shift.id && verificationMessageData.index === index && verificationMessageData.action === 'single_msg'"
                              small
                              style="margin-left: 5px;"
                            />
                          </b-button>
                          <b-button
                            type="button"
                            variant="outline-primary"
                            class="mt-1"
                            :disabled="sendingVerifications && verifyShiftsData.id === shift.id && verifyShiftsData.index === index && verifyShiftsData.action === 'single_verify'"
                            @click="showModalVerifyShifts('shift', shift.id, index, 'single_verify', shift.reservation.step > 2)"
                          >
                            {{ $t('action_center.verify') }}
                            <b-spinner
                              v-if="sendingVerifications && verifyShiftsData.id === shift.id && verifyShiftsData.index === index && verifyShiftsData.action === 'single_verify'"
                              small
                              style="margin-left: 5px;"
                            />
                          </b-button>
                          <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="outline-info"
                            type="button"
                            class="mt-1"
                            @click="showModalFreeShift(shift)"
                          >
                            {{ $t('shifts_calendar.cancel_options.btnText') }}
                          </b-button>
                          <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="outline-danger"
                            type="button"
                            class="mt-1"
                            @click="showModalCancelShift(shift)"
                          >
                            {{ $t('shifts_calendar.buttons.cancel_button') }}
                          </b-button>
                        </div>
                      </app-timeline-item>
                    </app-timeline>
                  </app-collapse-item>
                </app-collapse>
              </b-card-text>
            </b-card>
          </div>
        </div>
      </b-col>

      <b-modal
        id="modal-send-verification-message"
        ok-only
        ok-variant="primary"
        ok-title="Lähetä"
        modal-class="modal-warning"
        centered
        :title="`Lähetä vahvistus${verificationMessageData && verificationMessageData.type === 'area' ? 'kooste' : 'viesti'} kohteelle`"
        @ok="sendVerificationMessage"
      >
        <b-card-text
          v-if="verificationMessageData"
        >
          {{ `Haluatko varmasti lähettää vahvistus${verificationMessageData && verificationMessageData.type === 'area' ? 'koosteen' : 'viestin'}?` }}
        </b-card-text>
      </b-modal>

      <b-modal
        id="modal-verify-shifts"
        ok-only
        ok-variant="primary"
        ok-title="Vahvista"
        modal-class="modal-primary"
        centered
        :title="`Vahvista vuoro${verifyShiftsData && verifyShiftsData.type === 'area' ? 't' : ''}`"
        @ok="verifyShifts"
      >
        <b-card-text
          v-if="!verifyShiftsData.msgSent && appConfig.type === 'hw-admin'"
          style="font-weight: 500; font-size: 16;"
        >
          {{ `HUOM! ${verifyShiftsData.type === 'shift' ? 'Tästä vuorosta' : 'Kaikista vuoroista'} ei ole lähetetty vahvistusviestiä.` }}
        </b-card-text>
        <b-card-text
          v-if="verifyShiftsData"
        >
          {{ verifyShiftsData.type === 'shift' ? 'Haluatko varmasti vahvistaa tämän vuoron?' : 'Haluatko varmasti vahvistaa kaikki kohteen vuorot?' }}
        </b-card-text>
      </b-modal>

      <b-modal
        id="modal-cancel-shift"
        ok-only
        ok-variant="danger"
        :ok-title="$t('shifts_calendar.buttons.cancel_button')"
        modal-class="modal-danger"
        centered
        :title="$t('shifts_calendar.buttons.cancel_button')"
        :ok-disabled="!cancelShiftData.mobile || !cancelShiftData.email"
        @ok="onCancelShift"
        @hidden="onHiddenCancelShift"
      >
        <b-card-text class="mt-2">
          {{ $t('shifts_calendar.cancel_form.title') }}
        </b-card-text>
        <b-input-group prepend="FI (+358)">
          <b-form-input
            v-model="cancelShiftData.mobile"
            type="number"
            :placeholder="$t('shifts_calendar.cancel_form.mobile_placeholder')"
          />
        </b-input-group>

        <b-form-input
          v-model="cancelShiftData.email"
          type="email"
          :placeholder="$t('shifts_calendar.cancel_form.email_placeholder')"
          class="mt-2"
        />
      </b-modal>

      <b-modal
        id="modal-free-shift"
        ok-only
        ok-variant="info"
        :ok-title="$t('shifts_calendar.cancel_options.confirmBtnText')"
        centered
        :title="$t('shifts_calendar.cancel_options.title')"
        :ok-disabled="!cancelShiftData.mobile || !cancelShiftData.email"
        @ok="onFreeShift()"
        @hidden="onHiddenCancelShift"
      >
        <b-form-group>
          <v-select
            v-model="cancelShiftData.titleSelected"
            :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
            :options="titleOptions"
            :reduce="val => val.value"
            :clearable="false"
          />
        </b-form-group>
        <b-form-group v-if="cancelShiftData.titleSelected === 'option_1'">
          <p>{{ $t('message')}}:</p>
          <p>{{ getMessageFreeShift(cancelShiftData.shift).smsMessage }}</p>
        </b-form-group>
        <b-form-group v-else-if="cancelShiftData.titleSelected === 'option_2'">
          <p>{{ $t('message')}}:</p>
          <p>{{ getMessageFreeShift(cancelShiftData.shift).smsMessage }}</p>
        </b-form-group>
        <b-form-group v-else-if="cancelShiftData.titleSelected === 'option_3'">
          <p>{{ $t('message')}}:</p>
          <b-form-textarea
            v-model.trim="cancelShiftData.textAreaFormData"
            no-resize
            rows="5"
            maxlength="200"
          />
          <p
            class="mt-1"
            style="text-align:right;"
          >
            {{ cancelShiftData.textAreaFormData.length }} / 200
          </p>
        </b-form-group>
        <b-input-group prepend="FI (+358)">
          <b-form-input
            v-model="cancelShiftData.mobile"
            type="number"
            :placeholder="$t('shifts_calendar.cancel_form.mobile_placeholder')"
          />
        </b-input-group>

        <b-form-input
          v-model="cancelShiftData.email"
          type="email"
          :placeholder="$t('shifts_calendar.cancel_form.email_placeholder')"
          class="mt-2"
        />
      </b-modal>

      <quick-shift-list
        :processer="processer"
        :user="user"
        :create-client-request="createClientRequest"
        :create-confirmation-ticket="createConfirmationTicket"
        :update-shift="updateShift"
        @fetchShiftPikapalkka="fetchShiftPikapalkka"
        @sendConfimationToPayroll="sendConfimationToPayroll"
        @sendPikapalkkaSMS="sendPikapalkkaSMS"
      />
    </b-row>

    <past-shift-list
      :processer="processer"
      :user="user"
      :create-client-request="createClientRequest"
      :create-confirmation-ticket="createConfirmationTicket"
      :update-shift="updateShift"
      @fetchShiftPast="fetchShiftPast"
    />

  </div>
</template>

<script>
import AppTimeline from '@hw-ui/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@hw-ui/components/app-timeline/AppTimelineItem.vue'
import AppCollapse from '@hw-ui/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@hw-ui/components/app-collapse/AppCollapseItem.vue'
import {
  BCard, BCardText, BButton, BModal, BRow, BCol, BBadge,
  BFormGroup, BInputGroup, BFormInput, BFormTextarea, BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from '@hw-ui/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import FeatherIcon from '@hw-ui/components/feather-icon/FeatherIcon.vue'
import { capitalize } from '@hw-core/utils'
import { userHasWorkedInArea } from '@/shared/services/areaService' // TODO move in this module
import { firestore } from '@/shared/services/firebase'
import moment from 'moment'
import useActionCenterList from './useActionCenterList'
import QuickShiftList from './QuickShiftList.vue'
import PastShiftList from './PastShiftList.vue'

// eslint-disable-next-line no-unused-vars
function toHTMLMessage(message) {
  const array = message.split('\n')
  const htmlArray = array.map(elem => `<p>${elem}</p>`)
  return htmlArray.join('')
}

function createHTMLTable(items, columns) {
  let table = '<table role="presentation" border="0" cellspacing="0" width="100%" style="margin-bottom: 10px">'
  // Build table headers
  table += '<tr>'
  table += columns.map(column => `<th>${column.label}</th>`).join('')
  table += '</tr>'
  // Build table rows
  table += items.map(item => `<tr>${columns.map(field => `<td style="text-transform: capitalize">${item[field.value] ? item[field.value] : ''}</td>`).join('')}</tr>`).join('')
  table += '</table>'
  return table
}
export default {
  components: {
    AppTimeline,
    AppTimelineItem,
    BCard,
    BCardText,
    BButton,
    BModal,
    BRow,
    BCol,
    BBadge,
    AppCollapse,
    AppCollapseItem,
    vSelect,
    QuickShiftList,
    PastShiftList,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BFormTextarea,
    FeatherIcon,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  props: {},
  data() {
    return {
      shifts: [],
      areaIdList: [],
      accountIdList: [],
      sendingVerifications: false,
      sendingVerificationMessage: false,
      formVerifiedShifts: {
        areaId: null,
        shiftId: null,
        data: [],
        emails: [],
      },
      processer: {},
      titleOptions: [
        { label: this.$t('shifts_calendar.cancel_options.option_1', { msg: 'Option 1' }), value: 'option_1' },
        { label: this.$t('shifts_calendar.cancel_options.option_2', { msg: 'Option 2' }), value: 'option_2' },
        { label: this.$t('shifts_calendar.cancel_options.option_3', { msg: 'Option 3' }), value: 'option_3' },
      ],
      cancelShiftData: {
        titleSelected: 'option_1',
        textAreaFormData: '',
      },
      verifyShiftsData: {
        type: '',
        index: -1,
      },
      verificationMessageData: {
        type: '',
        index: -1,
      },
    }
  },
  computed: {
    user() {
      return this.$store.state.appAuth.authUser ? this.$store.state.appAuth.authUser : {}
    },
    appConfig() {
      return this.$store.state.app.appConfig || {}
    },
  },
  beforeCreate() {
    this.$store.dispatch('appAuth/getCurrentUser')
      .then(res => {
        const user = JSON.parse(JSON.stringify(res))
        if (user.role === 'admin') {
          this.customerSendVerification = true
        }
        this.processer = {
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
        }
      })
  },
  created() {
    this.fetchShifts(async change => {
      const { type, data } = change

      const reservationsCollection = await firestore()
        .collection('reservations')
        .where('assignedTo', '==', data.assignedTo)
        .where('shiftId', '==', data.id)
        .where('status', '==', 'pending')
        .get()

      if (reservationsCollection.empty) {
        return
      }

      const reservation = {
        ...reservationsCollection.docs[0].data(),
        id: reservationsCollection.docs[0].id,
      }

      if (type === 'added') {
        const isWorkedInArea = await userHasWorkedInArea(data)
        this.shifts.push({
          ...data,
          start: data.start.toDate(),
          end: data.end.toDate(),
          isWorkedInArea,
          reservation,
        })
        if (this.areaIdList && this.areaIdList.indexOf(data.areaId) === -1) {
          this.areaIdList.push(data.areaId)
        }
        if (this.accountIdList && this.accountIdList.indexOf(data.accountId) === -1) {
          this.accountIdList.push(data.accountId)
        }
      }
      if (change.type === 'removed') {
        if (this.areaIdList && this.areaIdList.some(item => item === data.areaId)) {
          if (this.getShiftByAreaId(data.areaId).length === 1) {
            this.areaIdList = this.areaIdList.filter(item => item !== data.areaId)
          }
        }
        if (this.accountIdList && this.accountIdList.some(item => item === data.accountId)) {
          if (this.getShiftByAccountId(data.accountId).length === 1) {
            this.accountIdList = this.accountIdList.filter(item => item !== data.accountId)
          }
        }
        this.shifts.forEach(shift => {
          const index = this.shifts.indexOf(shift)
          if (shift.id === data.id) {
            this.shifts.splice(index, 1)
          }
        })
      }
      if (change.type === 'modified') {
        this.shifts = this.shifts.map(shift => {
          if (shift.id === data.id) {
            return {
              ...shift,
              ...data,
              start: data.start.toDate(),
              end: data.end.toDate(),
              userHasWorkedInArea,
              reservation,
            }
          }
          return shift
        })
      }
    })

    setInterval(() => {
      this.shifts = this.shifts.map(shift => {
        const daysTill = moment(shift.start).diff(new Date(), 'days')
        const hoursTill = moment(shift.start).diff(new Date(), 'hours')
        const minutesTill = moment(shift.start).diff(new Date(), 'minutes')

        return {
          ...shift,
          daysTill,
          hoursTill,
          minutesTill,
        }
      })
    }, 1000)
  },
  methods: {
    getProcessor(shift) {
      return shift.updates[0].processer
    },
    getShiftByAreaId(areaId) {
      return this.shifts
        .filter(item => item.areaId === areaId)
        .sort((a, b) => {
          const c = new Date(a.startDate)
          const d = new Date(b.startDate)
          return c - d
        })
    },
    getShiftByAccountId(accountId) {
      return this.shifts
        .filter(item => item.accountId === accountId)
        .sort((a, b) => {
          const c = new Date(a.startDate)
          const d = new Date(b.startDate)
          return c - d
        })
    },
    getAreasByAccountId(accountId) {
      return this.shifts
        .filter(item => item.accountId === accountId)
        .map(item => item.areaId)
        .filter((value, index, self) => self.indexOf(value) === index)
    },
    getVerifMsgSentCount(shifts) {
      return shifts.filter(shift => shift.reservation.step > 2).length
    },
    async sendVerificationMessage() {
      const {type, id} = this.verificationMessageData
      this.sendingVerificationMessage = true

      const shifts = type === 'shift'
        ? this.shifts.filter(shift => shift.id === id && shift.reservation.step === 2)
        : this.shifts
          .filter(shift => shift.areaId === id  && shift.reservation.step === 2)
          .sort((a, b) => {
            const c = new Date(a.startDate)
            const d = new Date(b.startDate)
            return c - d
          })

      if (shifts.length > 0) {
        const { area } = shifts[0]
        const to = area.emails ? area.emails : []
        const location = this.capitalize(area.name)
        const verificationId = (new Date().getTime() + shifts[0].start.getTime()).toString().slice(0, 9)
        const subject = `#${verificationId} ${location} ${shifts.length === 1 ? 'vuoron' : 'vuorojen'} vahvistus`
        const columns = [
          {
            label: 'Varaaja',
            value: 'fullName',
          },
          {
            label: 'Nimike',
            value: 'role',
          },
          {
            label: 'Luvallinen',
            value: 'love',
          },
          {
            label: 'Ajokortti',
            value: 'drivingLicense',
          },
          {
            label: 'Puhelin',
            value: 'mobile',
          },
          {
            label: 'Pvm',
            value: 'date',
          },
          {
            label: this.$t('start'),
            value: 'start',
          },
          {
            label: 'Loppuu',
            value: 'end',
          },
        ]
        if (shifts.some(item => item.user.studies?.studyType && item.user.studies.studyType.length > 0)) {
          columns.splice(3, 0, {
            label: 'OP',
            value: 'credits',
          })
        }
        const items = await Promise.all(shifts.map(async shift => {
          const { user } = shift
          const { fullName, role, mobile } = user
          const start = shift.start.toLocaleString('fi', { hour: 'numeric', minute: 'numeric' })
          const end = shift.end.toLocaleString('fi', { hour: 'numeric', minute: 'numeric' })
          const date = shift.start.toLocaleString('fi', { month: 'numeric', day: 'numeric' })
          const love = user.love ? 'Kyllä' : 'Ei'
          const drivingLicense = user.drivingLicense && user.drivingLicense.length > 0 ? 'Kyllä' : 'Ei'
          let result = {
            fullName,
            role,
            love,
            drivingLicense,
            mobile,
            start,
            end,
            date,
          }
          // Check if user is student
          if (shift.user.profession && shift.user.profession === 'opiskelija') {
            const credits = shift.user.studies ? shift.user.studies.credits : ''
            result = {
              ...result, credits, role: shift.user.studies.studyType, love,
            }
          }
          return result
        }))
        const table = createHTMLTable(items, columns)
        let message = ''
        const messageStart = `
          <p>Hei,</p>
          <p>Kohteessa <b>${location}</b> on varattuja vuoroja. Pyytäisimme teitä vahvistamaan alla olevat vuorot vastaamalla tähän viestiin.
          <br></p>
        `
        const messageEnd = `
          <br>
          <p>Ystävällisin terveisin,
          <br>
          Hoiwa-tiimi</p>
        `
        message += messageStart
        message += table
        message += messageEnd

        try {
          const email = to[0]
          const cc = to.slice(1)

          await this.sendEmailWithCC({
            to: email,
            cc,
            subject,
            message,
          })

          await Promise.all(shifts.map(async shift => {
            const update = {
              processer: `${this.processer.firstName} ${this.processer.lastName}`,
              date: new Date(),
              state: 'verification_msg_sent',
              content: [`Vahvistusviesti lähetetty kohteelle seuraaviin osoitteisiin: '${to.join("', '")}'`],
            }
            const { updates } = shift
            updates.push(update)
            const reservationDoc = await firestore().collection('reservations').doc(shift.reservation.id).get()
            const reservation = reservationDoc.data()
            if(reservation.step < 3) {
              await firestore().collection('reservations').doc(shift.reservation.id).update({
                step: 3,
              })
            }
            await this.updateShift({ id: shift.id, updates: { updates, verificationId } })
          }))
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: this.$t('success'),
              text: 'Vahvistusviesti lähetetty',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.verificationMessageData = {
            type: '',
            index: -1,
          }
          this.sendingVerificationMessage = false
        } catch (e) {
          console.error(e)
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: this.$t('error'),
              text: this.$t('something_went_wrong'),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          this.verificationMessageData = {
            type: '',
            index: -1,
          }
          this.sendingVerificationMessage = false
        }
      }
    },
    async verifyShifts() {
      const {type, id} = this.verifyShiftsData
      this.sendingVerifications = true

      const shifts = type === 'shift'
        ? this.shifts.filter(shift => shift.id === id)
        : this.shifts
          .filter(shift => shift.areaId === id)
          .sort((a, b) => {
            const c = new Date(a.startDate)
            const d = new Date(b.startDate)
            return c - d
          })

      try {
        await Promise.all(shifts.map(async shift => {
          const update = {
            processer: `${this.processer.firstName} ${this.processer.lastName}`,
            date: new Date(),
            state: 'verified',
            content: ['Varaus vahvistettu'],
          }
          const { updates } = shift
          updates.push(update)
          await this.updateShift({ id: shift.id, updates: { reserved: true, updates } })
        }))
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('success'),
            text: 'Vuorot vahvistettu',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        this.verifyShiftsData = {
          type: '',
          index: -1,
        }
        this.sendingVerifications = false
      } catch (e) {
        console.error(e)
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('error'),
            text: this.$t('something_went_wrong'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
        this.verifyShiftsData = {
          type: '',
          index: -1,
        }
        this.sendingVerifications = false
      }
    },

    sendConfimationToPayroll(shifts) {
      const requester = 'imam.ali@hoiwa.fi'
      const groupId = '360007929178'
      const subject = `${this.capitalize(shifts[0].area.name)}: Pikapalkka vuoro vahvistettu`
      const columns = [{
        label: 'Vuorontekijä',
        value: 'fullName',
      },
      {
        label: 'Pvm',
        value: 'date',
      },
      {
        label: 'Alkoi',
        value: 'start',
      },
      {
        label: 'Loppui',
        value: 'end',
      },
      ]
      const items = shifts.map(shift => {
        const { user } = shift
        const { fullName } = user
        const start = shift.start.toLocaleString('fi', { hour: 'numeric', minute: 'numeric' })
        const end = shift.end.toLocaleString('fi', { hour: 'numeric', minute: 'numeric' })
        const date = shift.start.toLocaleString('fi', { month: 'numeric', day: 'numeric' })
        return {
          fullName,
          start,
          end,
          date,
        }
      })
      const table = createHTMLTable(items, columns)
      let message = ''
      const messageStart = `<p>Hei,</p>
                  <p>Pikapalkka vuorot vahvistettu kohteelta. Palkat tulostettu Pikapalkka kohtaan. Vuorot voi pistää maksuun. HR vahvistaja: <span style="text-transform: capitalize">${this.processer.firstName} ${this.processer.lastName}</span></p>`
      const messageEnd = `
                  <p>Ystävällisin terveisin,</p>
                  <p>Hoiwa ‑tiimi</p>`
      message += messageStart

      message += table

      message += messageEnd
      this.createConfirmationTicket({
        requester,
        groupId,
        message,
        subject,
      })
    },
    async sendPikapalkkaSMS(shifts) {
      let smsMessage = ''
      try {
        await Promise.all(shifts.map(async shift => {
          const { user } = shift
          const date = shift.start.toLocaleString('fi', { month: 'numeric', day: 'numeric' })
          smsMessage = `Hei ${this.capitalize(user.firstName)}! Pikapalkka vuorosi ajalta ${date} on kohteelta vahvistettu! Pistämme palkkan vuorosta maksuun. Yst.Hoiwa-tiimi`
          await this.sendConfirmNotificationSMS({
            mobile: user.mobile,
            message: smsMessage,
          })
        }))
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('success'),
            text: this.$t('action_center.toast_message.send_pikapalkka_sms_success'),
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('error'),
            text: this.$t('something_went_wrong'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    showModalSendVerificationMessage(type, id, index, action) {
      this.verificationMessageData = {
        type,
        id,
        index,
        action,
      }
      this.$bvModal.show('modal-send-verification-message')
    },
    showModalVerifyShifts(type, id, index, action, msgSent) {
      this.verifyShiftsData = {
        type,
        id,
        index,
        action,
        msgSent,
      }
      this.$bvModal.show('modal-verify-shifts')
    },
    showModalFreeShift(shift) {
      this.cancelShiftData = {
        ...this.cancelShiftData,
        email: shift.user.email ? shift.user.email : '',
        mobile: shift.user.mobile ? shift.user.mobile : '',
        shift,
      }
      this.$bvModal.show('modal-free-shift')
    },
    showModalCancelShift(shift) {
      this.cancelShiftData = {
        ...this.cancelShiftData,
        email: shift.user.email ? shift.user.email : '',
        mobile: shift.user.mobile ? shift.user.mobile : '',
        shift,
      }
      this.$bvModal.show('modal-cancel-shift')
    },
    getMessageFreeShift(shift) {
      let emailMessage = ''
      let smsMessage = ''
      if (shift) {
        const name = shift.user ? capitalize(shift.user.firstName) : ''
        const start = shift.start?.toLocaleString('fi', {
          day: 'numeric', month: 'numeric', hour: 'numeric', minute: 'numeric',
        })
        const end = shift.end?.toLocaleString('fi', { hour: 'numeric', minute: 'numeric' })
        const verificationSection = shift.area.location.sectionInfo
        const shiftTitle = verificationSection ? capitalize(verificationSection) : ''
        if (this.cancelShiftData.titleSelected === 'option_1') {
          emailMessage = `<p>Hei ${name},</p>
<p>emme voi vahvistaa vuoroa ${shiftTitle} ajalla ${start} - ${end} sillä valitettavasti vuoro vaati perehdytyksen. Pahoittelut tästä.</p><p>Yst.Terveisin - Hoiwa tiimi</p>`
          smsMessage = `Hei  ${name},
emme voi vahvistaa vuoroa ${shiftTitle} ajalla ${start} - ${end} sillä valitettavasti vuoro vaati perehdytyksen. Pahoittelut tästä. Yst.Terveisin - Hoiwa tiimi`
        } else if (this.cancelShiftData.titleSelected === 'option_2') {
          emailMessage = `<p>Hei ${name},</p>
<p>emme voi vahvistaa vuoroa ${shiftTitle} ajalla ${start} - ${end} sillä valitettavasti et täytä kaikkia vuoron vaatimuksia. Pahoittelut tästä.</p><p>Yst.Terveisin - Hoiwa tiimi</p>`
          smsMessage = `Hei ${name},
emme voi vahvistaa vuoroa ${shiftTitle} ajalla ${start} - ${end} sillä valitettavasti et täytä kaikkia vuoron vaatimuksia. Pahoittelut tästä. Yst.Terveisin - Hoiwa tiimi`
        }
      }

      return { emailMessage, smsMessage }
    },
    async onFreeShift() {
      this.hideContractCard = true
      const toastId = this.$toast({
        component: ToastificationContent,
        props: {
          title: this.$t('action_center.toast_message.waiting_free_shift'),
          icon: 'UserIcon',
          variant: 'info',
        },
      },
      {
        timeout: 0,
      })
      try {
        const { email, mobile, shift } = this.cancelShiftData
        let { emailMessage, smsMessage } = this.getMessageFreeShift(shift)

        if (emailMessage.length < 1) {
          emailMessage = toHTMLMessage(this.cancelShiftData.textAreaFormData)
          smsMessage = this.cancelShiftData.textAreaFormData
        }

        // Step 1 Send Email
        await this.sendConfirmationEmail({
          to: email,
          message: emailMessage,
          subject: 'Vuoroa ei voida vahvista',
        })

        // Step 2 Send SMS
        await this.sendConfirmNotificationSMS({
          mobile,
          message: smsMessage,
        })

        // Step 3 Update shift
        const { updates } = shift
        updates.push({
          content: [`cancelShift: ${this.cancelShiftData.titleSelected}`],
          processer: `${this.processer.firstName} ${this.processer.lastName}`,
          date: new Date(),
          state: 'cancelled',
        })
        await this.updateShift({
          id: shift.id,
          updates: {
            updates,
            assignedTo: '',
            status: 'open',
            title: shift.area.location.sectionInfo,
          },
        })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('action_center.toast_message.free_shift_error'),
            icon: 'UserIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.$toast.dismiss(toastId)
      }
    },
    getMessageCancelShift(shift) {
      let emailMessage = ''
      let smsMessage = ''
      if (shift) {
        const name = shift.user ? capitalize(shift.user.firstName) : ''
        const start = shift.start?.toLocaleString('fi', {
          day: 'numeric', month: 'numeric', hour: 'numeric', minute: 'numeric',
        })
        const end = shift.end?.toLocaleString('fi', { hour: 'numeric', minute: 'numeric' })
        const verificationSection = shift.area.location.sectionInfo
        const shiftTitle = verificationSection ? capitalize(verificationSection) : ''
        emailMessage = `<p style="text-transform:capitalize">Hei ${name},</p>
                    <p>varaamaasi vuoroa <b>${shiftTitle} </b>ajalle <b>${start}</b> - <b>${end}</b> ei valitettavasti voida vahvistaa, koska kohde ilmoitti, että vuoro ehiti mennä toiselle toimijalle. Pahoittelut tästä.</p>
                    <p>Terveisin,</p>
                    <p>Hoiwa-tiimi</p>
                `
        smsMessage = `Hei ${name}, varaamaasi vuoroa ${shiftTitle} ajalle ${start} - ${end} ei valitettavasti voida vahvistaa, koska kohde ilmoitti, että vuoro ehti mennä toiselle toimijalle. Pahoittelut tästä.
  Terveisin Hoiwa-tiimi`
      }

      return { emailMessage, smsMessage }
    },
    async onCancelShift() {
      const toastId = this.$toast({
        component: ToastificationContent,
        props: {
          title: this.$t('action_center.toast_message.waiting_cancel_shift'),
          icon: 'UserIcon',
          variant: 'info',
        },
      },
      {
        timeout: 0,
      })
      try {
        const { email, mobile, shift } = this.cancelShiftData
        const { emailMessage, smsMessage } = this.getMessageCancelShift(shift)
        // Step 1 Send Email
        await this.sendConfirmationEmail({
          to: email,
          message: emailMessage,
          subject: 'Vuoroa ei voida vahvista',
        })

        // Step 2 Send SMS
        await this.sendConfirmNotificationSMS({
          mobile,
          message: smsMessage,
        })

        // Step 3 Update shift
        const { updates } = shift
        updates.push({
          content: ['Asiakas peruuttanut vuoron'],
          processer: `${this.processer.firstName} ${this.processer.lastName}`,
          date: new Date(),
          state: 'expired',
        })

        await this.updateShift({
          id: shift.id,
          updates: {
            updates,
            status: 'expired',
          },
        })
      } catch (error) {
        this.$toast.dismiss(toastId)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('action_center.toast_message.free_shift_error'),
            icon: 'UserIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.$toast.dismiss(toastId)
      }
    },
    onHiddenCancelShift() {
      this.cancelShiftData = {
        titleSelected: 'option_1',
        textAreaFormData: '',
      }
      delete this.cancelShiftData.email
      delete this.cancelShiftData.mobile
      delete this.cancelShiftData.shift
    },
  },
  setup() {

    const {
      refShifts,
      fetchShifts,
      sendConfirmationEmail,
      createConfirmationTicket,
      updateConfirmationTicket,
      fetchShiftPikapalkka,
      fetchShiftPast,
      sendConfirmNotificationSMS,
      updateShift,
      createClientRequest,
      sendEmailWithCC,
    } = useActionCenterList()

    return {
      refShifts,
      fetchShifts,
      sendConfirmationEmail,
      sendEmailWithCC,
      createConfirmationTicket,
      updateConfirmationTicket,
      fetchShiftPikapalkka,
      fetchShiftPast,
      sendConfirmNotificationSMS,
      updateShift,
      createClientRequest,
    }
  },
}
</script>
<style lang="scss">
@import '@hw-ui/scss/vue/libs/vue-flatpicker.scss';
</style>

<style scoped>
  .header-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .header-title {
    font-size: 16px;
  }
  .btn-confirm {
    max-height: 38px;
  }
  .capitalized {
    text-transform: capitalize;
  }
  .card-title {
    margin-bottom: 0.5rem;
  }
</style>
